import { FC } from "react";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";

export type RecurrenceCardLayoutSlots = {
  header: React.ReactNode;
  actions: React.ReactNode;
  content: React.ReactNode;
};

export interface RecurrenceCardLayoutProps {
  slots: RecurrenceCardLayoutSlots;
  isTitleFieldLabel?: boolean;
}

const HEADER_MIN_HEIGHT = 36;

export const RecurrenceCardLayout: FC<RecurrenceCardLayoutProps> = ({ slots, isTitleFieldLabel = false }) => (
  <Paper
    sx={(theme) => ({
      padding: isTitleFieldLabel ? theme.spacing(2, 3) : theme.spacing(1.5, 3, 3),
      backgroundColor: theme.palette.surface.neutral.supershy,
      boxShadow: "none",
    })}
  >
    <Grid container sx={{ position: "relative" }}>
      <Grid item xs={12}>
        <Grid container alignItems="center" sx={{ minHeight: isTitleFieldLabel ? undefined : HEADER_MIN_HEIGHT }}>
          <Grid item xs>
            {slots.header}
          </Grid>
          <Grid item xs="auto" sx={{ zIndex: 99 }}>
            {slots.actions}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sx={{ paddingTop: isTitleFieldLabel ? 0 : 1 }}>
        {slots.content}
      </Grid>
    </Grid>
  </Paper>
);
